import React from 'react';
import {
  useGetComprehensiveReportMutation,
  useGetComprehensiveReportOptionsMutation,
  useSetComprehensiveReportOptionsMutation,
  useGetViewStandardMutation
} from '../../../../../../features/authentication/reportApiSlice';
import { faMinus, faPlus,faCaretUp,faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectFerpaState } from '../../../../../../features/authentication/authSlice';
import { faCheck, faClose } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import CustomToast from '../../../../../../components/Toast';
import {
  convertToCSV,
  downloadCSV,
  reorderObjectProperties
} from '../../../../utils';
import html2pdf from 'html2pdf.js';
import Skeleton from 'react-loading-skeleton';
import Modals from '../StudentSessionReport/components/Modals';
import { ComprehensiveUtils } from './ComprehensiveUtils';
import HeaderToolbarContent from '../../../../../../components/TimeOnTaskReport/HeaderToolbar';
import { useSelector } from 'react-redux';

const ComprehensiveReport = () => {
  const [getComprehensiveReport] = useGetComprehensiveReportMutation();
  const [getComprehensiveReportOptions] = useGetComprehensiveReportOptionsMutation();
  const [setComprehensiveReportOptions] = useSetComprehensiveReportOptionsMutation();
  const [getStandard] = useGetViewStandardMutation();
  const [loader, setLoader] = React.useState(false);
  const [comprehensiveReportData, setComprehensiveReportData] = React.useState([]);
  const [incompleteScoringOption, setIncompleteScoringOption] = React.useState(false);
  const [selectedClassId, setSelectedClassId] = React.useState(-1);
  const ferpaEnabled = useSelector(selectFerpaState);
  const [scoringOption, setScoringOption] = React.useState('');
  const { Id } = useParams();
  const [selectedClassName, setSelectedClassName] = React.useState('');
  const [isClassChanged, setIsClassChanged] = React.useState(false);
  const [expand, setExpand] = React.useState(true);
  const [dataOption, setDataOption] = React.useState('');
  const [retriesOption, setRetriesOption] = React.useState('');
  const [showCount, setShowCount] = React.useState(false);
  const [showDate, setShowDate] = React.useState(false);
  const [reportOptions, setReportOptions] = React.useState(null);
  const [retries, setRetries] = React.useState(0);
  const [initial, setInitial] = React.useState(false);
  const [isAscending, setIsAscending] = React.useState(true);
  const [sortId, setSortId] = React.useState('lastName');
  const [openStandardModal, setOpenStandardModal] = React.useState(false);
  const [viewStandardDetails, setViewStandardDetails] = React.useState({});
  const [isExporting, setIsExporting] = React.useState(false);
  const [isDownloading, setIsDownloading] = React.useState(false);

  React.useEffect(() => {
    getReportOptions();
  }, []);

  React.useEffect(() => {
    if(isClassChanged){
      setIsClassChanged(false);
      fetchComprehensiveReportData();
    }
  }, [isClassChanged]);

  React.useEffect(() => {
    if(reportOptions != null && !initial){
      setInitial(true);
      fetchComprehensiveReportData();
    }
  }, [reportOptions]);

  const getReportOptions = async () => {
    try {
      const response = await getComprehensiveReportOptions().unwrap();
      setRetries(response.retries);
      //set score options
      setScoringOption('percentage');
      if (response.scoreOption) 
        setScoringOption('point');
      
      //set retries options
      setRetriesOption('fullCredit');
      if(response.retries === 1)
        setRetriesOption('noCredit');  
      else if(response.retries === 2)
        setRetriesOption('halfCredit');
      
      setIncompleteScoringOption(response.incompleteScoring);
      setShowDate(response.showDates);
      setShowCount(response.showCounts);
      
      if(response.dataOption === 1)
        setDataOption('showStandard'); 
      else if(response.dataOption === 2)
        setDataOption('showStudentAnswer');  
      else
        setDataOption('noData');
      
      setReportOptions(response);
    } catch (error) {
      console.log(error);
    }
  };
  
  const getIndividualScore=(reportData,retries,scoreOption)=>{
    let newReportData = [];
    reportData.comprehensiveReportData.map((student)=>{
      let score ='';
      const studentObj = {
        crPoints : student.crPoints,
        correct : student.correct,
        inCorrect : student.inCorrect,
        correctOnRetry : student.correctOnRetry,
        crAnswered : student.crAnswered,
        questionCount : student.questionCount,
        crMaxPoints : student.crMaxPoints,
        isSchoology : student.isSchoology,
        scoreOption : scoreOption
      };
      switch (retries) {
      case 1:
        score =  ComprehensiveUtils.getScoreNoCredit(studentObj);
        break;
      case 2:
        score = ComprehensiveUtils.getScoreWithRetryAsHalfCredit(studentObj);
        break;
      case 3:
        score = ComprehensiveUtils.getScoreWithRetryFullCredit(studentObj);
        break;
      }

      let standardScoreList = Array(reportData.standards?.length).fill(0);
      if(student.standardScores?.length>0)
        standardScoreList = ComprehensiveUtils.getStandardScore(student.standardScores,scoreOption,retries);
      newReportData.push({...student,score:score,standardScore:standardScoreList});
    });
    const updatedReportData  = {...reportData, comprehensiveReportData : newReportData};
    setComprehensiveReportData(updatedReportData);
  };

  const fetchComprehensiveReportData = async () => {
    setLoader(true);
    const data = {
      assignmentId: Id,
      classId: selectedClassId
    };

    try {
      const response = await getComprehensiveReport(data);
      if (response.error) {
        if (response.error.data.errors)
          CustomToast(response.error.data.errors.Description, 'error');
        else
          CustomToast(response.error.data.error, 'error');
      } else if (response.data) {
        getIndividualScore(response.data, retries, scoringOption === 'point');
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      CustomToast(error.data, 'error');
      console.log(error);
    }
  };

  const handleClassSelectionChange = (selectedClassId) => {
    setSelectedClassId(selectedClassId);
    setIsClassChanged(!isClassChanged);
  };

  const updateReportOptions= async (newReportOption) => {
    setReportOptions(newReportOption);
    await setComprehensiveReportOptions(newReportOption).unwrap();
  };

  const handlePrintPdf = async () => {
    setIsDownloading(true);
    // Generate the PDF from the HTML content
    const contentWrapper = document.getElementById('comprehensive_pdf_Wrapper');
    const contentClone = contentWrapper.cloneNode(true);
    const buttonGroup = contentClone.querySelector('#buttonGroup');
    buttonGroup.classList.add('d-none');
    const dropDownContainer = contentClone.querySelector('#dropdown_container');
    dropDownContainer.classList.add('d-none');
    const tables = document.getElementsByTagName('table');

    // Apply CSS styles to tables
    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    // Apply CSS styles to div
    const options = {
      margin: 60, // Specify the margin for all sides (top, right, bottom, left)
      image: { type: 'jpeg', quality: 0.98 }, // Set the image type and quality (optional)
      html2canvas: { scale: 2 }, // Set the scale for better quality (optional)
      jsPDF: { unit: 'pt', format: 'a0', orientation: 'landscape' }, // Set the document format and orientation (optional)
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
      }
    };

    await html2pdf().set(options).from(contentClone).save('ComprehensiveReport.pdf');
    setIsDownloading(false);
  };

  const exportHandler = async () => {
    setIsExporting(true);
    const studentList = [];
    comprehensiveReportData.comprehensiveReportData.forEach((student) => {
      let studentObj = {
        LastName: ferpaEnabled ? student.lastName : 'Lastname hidden',
        FirstName: ferpaEnabled ? student.firstName : 'Firstname hidden',
        Identification: ferpaEnabled ? student.identification : 'Id hidden',
        Score: student.score
      };

      if(showDate){
        studentObj = {...studentObj, AssignedDate:student.assignedDate, StartedDate:student.startedDate, CompletedDate:student.completedDate};
      }

      if(showCount){
        studentObj = {...studentObj, Correct:student.correct, Incorrect:student.inCorrect, CorrectOnRetry:student.correctOnRetry};
      }

      if(dataOption === 'showStandard'){
        let standardObj = {'Standard Score': ''};
        for (let i = 0; i < comprehensiveReportData.standards.length; i++) {
          standardObj = {...standardObj , [comprehensiveReportData.standards[i].standardNumber] : student.standardScore[i]};    
        }
        studentObj = {...studentObj, ...standardObj};
      }
      let studentAnswerObj = {'Questions' : ''};
      if(dataOption === 'showStudentAnswer'){
        for (let i = 0; i < comprehensiveReportData.questionCount; i++) {
          studentAnswerObj = {...studentAnswerObj , ['Q'+[i+1]] : student.answer[i]};    
        }
        studentObj = {...studentObj, ...studentAnswerObj};
      }
      studentList.push(studentObj);      
    });
    const newData = {
      Students : studentList,
    };
    const newDataWithReportOptionsFirst = reorderObjectProperties(newData, 'Students');
    const csvData = convertToCSV(newDataWithReportOptionsFirst);
    let modifiedCsv = csvData.replace('undefined', '');
    downloadCSV(modifiedCsv, 'Comprehensive Report-' + comprehensiveReportData.assignmentName );
    setIsExporting(false);
  };

  function generateQuestionHeaders(){
    let questionHeaders =[];
    for (let i = 1; i <= comprehensiveReportData.questionCount; i++) {
      questionHeaders.push(<td className='text-center border border-1'>{i}</td>);
    }
    return questionHeaders;
  }

  const handleScoreOption = async (e) => {
    let option = 'percentage';
    if (e.target.id==='radioPoints') 
      option = 'point';
    
    setScoringOption(option);
    const newReportOption = {...reportOptions, scoreOption:option === 'point'};
    updateReportOptions(newReportOption);
    getIndividualScore(comprehensiveReportData, retries, option==='point');
  };

  const handleRetries=(e)=>{
    let retryValue=0;
    if(e.target.id==='noCredit'){
      retryValue = 1;
      setRetriesOption('noCredit');
    }
    else if(e.target.id==='halfCredit'){
      retryValue = 2;
      setRetriesOption('halfCredit');
    }
    else if (e.target.id==='fullCredit'){
      retryValue = 3;
      setRetriesOption('fullCredit');
    }
    const newReportOption = {...reportOptions,retries:retryValue};
    updateReportOptions(newReportOption);
    setRetries(retryValue);
    getIndividualScore(comprehensiveReportData,retryValue,scoringOption === 'point');
  };

  const handleIncompleteScoringOptionChange = async (e) => {
    setIncompleteScoringOption(e.target.checked);
    const newReportOption = {...reportOptions,incompleteScoring:e.target.checked};
    await updateReportOptions(newReportOption);
    await fetchComprehensiveReportData();
  };

  const handleShowData=(e)=>{
    let dataViewValue = 0;
    if(e.target.id==='noData')
      setDataOption('noData');
    else if(e.target.id==='showStandardScore'){
      dataViewValue = 1;
      setDataOption('showStandard');
    }
    else{
      dataViewValue = 2;
      setDataOption('showStudentAnswer');
    }
    const newReportOption = {...reportOptions,dataOption:dataViewValue};
    updateReportOptions(newReportOption);
  };

  const handleDate=(e)=>{
    setShowDate(e.target.checked);
    const newReportOption = {...reportOptions,showDates:e.target.checked};
    updateReportOptions(newReportOption);
  };

  const handleCount=(e)=>{
    setShowCount(e.target.checked);
    const newReportOption = {...reportOptions,showCounts:e.target.checked};
    updateReportOptions(newReportOption);
  };

  const handleSort = (e) => {
    let sortAsc = true;
    const currentSortId = e.currentTarget.id;
    if(currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);
    customSort(comprehensiveReportData.comprehensiveReportData,currentSortId,sortAsc);
  };

  function customSort(studentData, property, sortAsc) {
    studentData.sort((a, b) => {
      // Convert values to strings for consistent comparison
      let valueA = typeof a[property] === 'string' ? a[property].toLowerCase() : String(a[property]);
      let valueB = typeof b[property] === 'string' ? b[property].toLowerCase() : String(b[property]);

      // Compare values
      if (sortAsc) {
        if (valueA < valueB) return -1;
        if (valueA > valueB) return 1;
        return 0; // Values are equal
      } else {
        if (valueA > valueB) return -1;
        if (valueA < valueB) return 1;
        return 0; // Values are equal
      }
    });
    setIsAscending(sortAsc);
    setComprehensiveReportData(reportData => ({ ...reportData, comprehensiveReportData: studentData}));
  }

  const handleStandard= async (standard)=>{
    const option = {
      stateCourseId: parseInt(standard.stateCourseId),
      standardNumber: String(standard.standardNumber),
      stateId: standard.stateId
    };
    try {
      const { data } = await getStandard(option);
      setViewStandardDetails(data);
      setOpenStandardModal(true);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="white-card" id="comprehensive_pdf_Wrapper">
        <HeaderToolbarContent
          reportTitle='Comprehensive Report' 
          setSelectedClassName={setSelectedClassName} 
          onClassChange={x=>{handleClassSelectionChange(x);}}
          printHandler={handlePrintPdf}
          exportHandler={exportHandler}
          isExporting={isExporting}
          isDownloading={isDownloading}
        />
        <div className="student_response_details">
          <div className="d-flex justify-content-between">
            {!loader ? (
              <>
                <div className="student_response_details_left">
                  <p>
                Assignment: <strong>{comprehensiveReportData?.assignmentName}</strong>
                  </p>
                  <p>
                Course: <strong>{comprehensiveReportData?.courseName}</strong>
                  </p>
                  <p>
                Teacher: <strong>{comprehensiveReportData?.teacherName}</strong>
                  </p>
                </div>
                <div className="student_response_details_right">
                  <p>
                School: <strong>{comprehensiveReportData?.schoolName}</strong>
                  </p>
                  <p>
                Class: <strong>{selectedClassName !== '' ? selectedClassName : comprehensiveReportData?.className}</strong>
                  </p>
                  <p>
                Report Date: <strong>{comprehensiveReportData?.reportDate}</strong>
                  </p>
                </div>
              </>
            ):(
              <>
                <div className="w-100 row">
                  {[...Array(3)].map((_, index) => (
                    <div className='col-6 mb-3' key={index}>
                      <Skeleton />
                    </div>
                  ))}
                  {[...Array(3)].map((_, index) => (
                    <div className='col-6 mb-3' key={index}>
                      <Skeleton />
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
        <div id="reportOptionsDiv" className="d-flex align-item-center report-button gap-1">
            Report Options
          {
            <div className='cursor-pointer' onClick={() => setExpand(!expand)}>
              {expand ? <FontAwesomeIcon icon={faMinus} /> : <FontAwesomeIcon icon={faPlus} />}
            </div>
          }
        </div>
        {expand && 
        <div className="report-options mt-4">
          <div className='fs-5'>Scoring</div>
          <div className='d-flex mt-2'>
            <div>
              <p className='fw-500'>Show score as</p>
            </div>
            <div className='ml-8'>
              <p className='fw-500'>Retries</p>
            </div>
          </div>
          <div className="d-flex mt-2">
            <div className="d-flex gap-1 me-3">
              <input
                type="radio"
                className="form-check-input cursor-pointer"
                checked={scoringOption === 'point'}
                id="radioPoints"
                name="scoreRadioBtn"
                onChange={(e) => handleScoreOption(e)}
              />
              <label className="form-check-label">
                Points
              </label>
            </div>
            <div className="d-flex gap-1">
              <input
                type="radio"
                className="form-check-input cursor-pointer"
                checked={scoringOption === 'percentage'}
                id="radioPercentage"
                name="scoreRadioBtn"
                onChange={(e) => handleScoreOption(e)}
              />
              <label className="form-check-label">
                Percentage
              </label>
            </div>
            <div className="d-flex mx-5">
              <div className="d-flex gap-1 me-3">
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  checked={retriesOption === 'noCredit'}
                  id="noCredit"
                  name="retriesRadioBtn"
                  onChange={(e) => handleRetries(e)}
                />
                <label className="form-check-label">
                Score with retries as no credit
                </label>
              </div>
              <div className="d-flex gap-1 me-3">
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  checked={retriesOption === 'halfCredit'}
                  id="halfCredit"
                  name="retriesRadioBtn"
                  onChange={(e) => handleRetries(e)}
                />
                <label className="form-check-label">
                Score with retries as half credit
                </label>
              </div>
              <div className="d-flex gap-1">
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  checked={retriesOption === 'fullCredit'}
                  id="fullCredit"
                  name="retriesRadioBtn"
                  onChange={(e) => handleRetries(e)}
                />
                <label className="form-check-label">
                Score with retries as full credit
                </label>
              </div>
            </div>
          </div>
          <div className="mt-3">
            <input
              type="checkbox"
              className="form-check-input me-2 cursor-pointer"
              checked={incompleteScoringOption}
              id="flexCheckDefault"
              name="allselect"
              onChange={handleIncompleteScoringOptionChange}
            />
            <label className="form-check-label">
                Score unanswered questions as incorrect
            </label>
          </div>
          <div className='mt-3'>
            <div className='fs-5'>Data</div>
            <div className="d-flex mt-2">
              <div className="d-flex gap-1 me-3">
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  checked={dataOption === 'noData'}
                  id="noData"
                  name="dataRadioBtn"
                  onChange={(e) => handleShowData(e)}
                />
                <label className="form-check-label">
                No additional data
                </label>
              </div>
              <div className="d-flex gap-1 me-3">
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  checked={dataOption === 'showStandard'}
                  id="showStandardScore"
                  name="dataRadioBtn"
                  onChange={(e) => handleShowData(e)}
                />
                <label className="form-check-label">
                Show Standard Scores
                </label>
              </div>
              <div className="d-flex gap-1">
                <input
                  type="radio"
                  className="form-check-input cursor-pointer"
                  checked={dataOption === 'showStudentAnswer'}
                  id="showStudentAnswer"
                  name="dataRadioBtn"
                  onChange={(e) => handleShowData(e)}
                />
                <label className="form-check-label">
                Show Student Answers
                </label>
              </div>
            </div>
          </div>
          <div className='mt-3'>
            <div className='fs-5'>Other</div>
            <div className='d-flex mt-2'>
              <div className="me-3">
                <input
                  type="checkbox"
                  className="form-check-input me-2 cursor-pointer"
                  checked={showDate}
                  id="dateCheck"
                  name="showDateCheck"
                  onChange={handleDate}
                />
                <label className="form-check-label">
                Show dates(assigned,started,completed)
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  className="form-check-input me-2 cursor-pointer"
                  checked={showCount}
                  id="scoreOption"
                  name="scoreOptionCheck"
                  onChange={handleCount}
                />
                <label className="form-check-label">
                Show correct,incorrect and correct-on-retry counts
                </label>
              </div>
            </div>
          </div>
        </div>
        }
          
        <div className="mt-5 custom-table table-responsive">
          {!loader && comprehensiveReportData.comprehensiveReportData?.length > 0 &&
              <table className='w-100'>        
                <tr className="score-table-head">
                  <th id="lastName" rowSpan={dataOption === 'noData'? '':2} onClick={(e)=> ferpaEnabled ? handleSort(e) : ''} className={ferpaEnabled ?'cursor-pointer':''}>
                    <div className='d-flex flex-column-reverse'>
                      <div>
                    Last Name
                      </div>
                      {ferpaEnabled &&
                    <div>
                      <button className="sort-btn row text-grey">
                        <FontAwesomeIcon icon={faCaretUp}  className={`${sortId === 'lastName' && isAscending ? 'enabled-caret':''}`}/>
                        <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === 'lastName' && !isAscending ? 'enabled-caret':''}`}/>
                      </button>
                    </div>
                      }
                    </div>
                  </th>
                  <th id="firstName" rowSpan={dataOption === 'noData'? '':2} onClick={(e)=>ferpaEnabled ? handleSort(e) : ''} className={ferpaEnabled ?'cursor-pointer':''}>
                    <div className='d-flex flex-column-reverse'>
                      <div>
                    First Name
                      </div>
                      {ferpaEnabled &&
                    <div>
                      <button className="sort-btn row text-grey">
                        <FontAwesomeIcon icon={faCaretUp}  className={`${sortId === 'firstName' && isAscending ? 'enabled-caret':''}`}/>
                        <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === 'firstName' && !isAscending ? 'enabled-caret':''}`}/>
                      </button>
                    </div>
                      }
                    </div>
                  </th>
                  <th id="identification" rowSpan={dataOption === 'noData' ? '':2} onClick={(e)=>ferpaEnabled ? handleSort(e) : ''} className={ferpaEnabled ?'cursor-pointer':''}>
                    <div className='d-flex flex-column-reverse'>
                      <div>
                    Identification
                      </div>
                      {ferpaEnabled &&
                    <div>
                      <button className="sort-btn row text-grey">
                        <FontAwesomeIcon icon={faCaretUp}  className={`${sortId === 'identification' && isAscending ? 'enabled-caret':''}`}/>
                        <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === 'identification' && !isAscending ? 'enabled-caret':''}`}/>
                      </button>
                    </div>
                      }
                    </div>
                  </th>
                  {showDate &&
              <>
                <th id="assignedDate" rowSpan={dataOption === 'noData'? '':2} onClick={(e)=>handleSort(e)} className='cursor-pointer'>
                  <div className='d-flex flex-column-reverse'>
                    <div>
                    Date<br></br>Assigned
                    </div>
                    <div>
                      <button className="sort-btn row text-grey">
                        <FontAwesomeIcon icon={faCaretUp}  className={`${sortId === 'assignedDate' && isAscending ? 'enabled-caret':''}`}/>
                        <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === 'assignedDate' && !isAscending ? 'enabled-caret':''}`}/>
                      </button>
                    </div>
                  </div>
                </th>
                <th id="startedDate" rowSpan={dataOption === 'noData' ? '':2} onClick={(e)=>handleSort(e)} className='cursor-pointer'>
                  <div className='d-flex flex-column-reverse'>
                    <div>
                    Date<br></br>Started
                    </div>
                    <div>
                      <button className="sort-btn row text-grey">
                        <FontAwesomeIcon icon={faCaretUp}  className={`${sortId === 'startedDate' && isAscending ? 'enabled-caret':''}`}/>
                        <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === 'startedDate' && !isAscending ? 'enabled-caret':''}`}/>
                      </button>
                    </div>
                  </div>
                </th>
                <th id="completedDate" rowSpan={dataOption === 'noData' ? '':2} onClick={(e)=>handleSort(e)} className='cursor-pointer'>
                  <div className='d-flex flex-column-reverse'>
                    <div>
                    Date<br></br>Completed
                    </div>
                    <div>
                      <button className="sort-btn row text-grey">
                        <FontAwesomeIcon icon={faCaretUp}  className={`${sortId === 'completedDate' && isAscending ? 'enabled-caret':''}`}/>
                        <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === 'completedDate' && !isAscending ? 'enabled-caret':''}`}/>
                      </button>
                    </div>
                  </div>
                </th>
              </>
                  }
                  {showCount &&
              <>
                <th rowSpan={dataOption === 'noData' ? '':2}>
                  <FontAwesomeIcon icon={faCheck} />
                </th>
                <th rowSpan={dataOption === 'noData' ? '':2}>
                  <FontAwesomeIcon icon={faClose} />
                </th>
                <th className='px-3' rowSpan={dataOption === 'noData' ? '':2}>
                  <FontAwesomeIcon icon={faClose} /><FontAwesomeIcon icon={faCheck} /> 
                </th>
                <th rowSpan={dataOption === 'noData' ? '':2}>CR<br></br>Answered</th>
              </>
                  }
                  <th id="score" rowSpan={dataOption === 'noData' ? '':2} onClick={(e)=>handleSort(e)} className='cursor-pointer'>
                    <div className='d-flex flex-column-reverse'>
                      <div>
                    Score
                      </div>
                      <div>
                        <button className="sort-btn row text-grey">
                          <FontAwesomeIcon icon={faCaretUp}  className={`${sortId === 'score' && isAscending ? 'enabled-caret':''}`}/>
                          <FontAwesomeIcon icon={faCaretDown} className={`align-caret-down ${sortId === 'score' && !isAscending ? 'enabled-caret':''}`}/>
                        </button>
                      </div>
                    </div>
                  </th>
                  {dataOption === 'showStandard' &&
               <th colSpan={comprehensiveReportData.standards?.length}>Standard Score</th>
                  }
                  {dataOption === 'showStudentAnswer' &&
              <th colSpan={comprehensiveReportData.questionCount}>Questions</th>
                  }
                </tr>
                {dataOption === 'showStandard' &&
            <tr className='score-table-head'>
              {comprehensiveReportData.standards?.map((item)=>(
                <>
                  <td className='text-decoration-underline cursor-pointer border border-1' onClick={()=>handleStandard(item)}>{item.standardNumber}</td>
                </>
              ))}
            </tr>
                }
                {dataOption === 'showStudentAnswer' &&
            <tr className='score-table-head'>         
              {generateQuestionHeaders()}  
            </tr> 
                }
                {!loader&&
              <>
                {
                  <>
                    {comprehensiveReportData?.comprehensiveReportData?.map((item) => (
                      <tr className="tabel-body" key={`${item.studentId}-record`}>
                        {ferpaEnabled?<td>{item.lastName}</td>:<td>Lastname<br></br>hidden</td>}
                        {ferpaEnabled?<td>{item.firstName}</td>:<td>Firstname<br></br>hidden</td>}
                        {ferpaEnabled?<td>{item.identification}</td>:<td>Id<br></br>hidden</td>}
                        {showDate &&
                        <>
                          <td>{item.assignedDate}</td>
                          <td>{item.startedDate}</td>
                          <td>{item.completedDate}</td>
                        </>
                        }
                        {showCount && 
                        <>
                          <td>{item.correct}</td>
                          <td>{item.inCorrect}</td>
                          <td>{item.correctOnRetry}</td>
                          <td>{item.crAnswered}</td>
                        </>
                        }
                        <td>{item.score}</td>
                        {item.standardScore?.map((standardScore)=>(
                          <>
                            {dataOption === 'showStandard' &&
                            <td className='border border-1'>{standardScore}</td>
                            }
                          </>
                        ))}
                                                                    
                        {item.answer?.map((answer)=>(
                          <>
                            {dataOption === 'showStudentAnswer' &&
                            <td className='border border-1'>{answer}</td>
                            }
                          </>                         
                        ))}                                                  
                      </tr>
                    ))}
                  </>
                }
              </>
                }
              </table>
          }{loader &&
              <>
                <table className='w-100 mt-5'>
                  {[...Array(1)].map((_, index) => (
                    <tr className='score-table-head' key={index}>
                      {[...Array(4)].map((_, index) => (
                        <th key="index">
                          <Skeleton />
                        </th>
                      ))}
                    </tr>
                  ))}
                  {[...Array(10)].map((_, index) => (
                    <tr key={index}>
                      {[...Array(4)].map((_, index) => (
                        <td key="index">
                          <Skeleton />
                        </td>
                      ))}
                    </tr>
                  ))}
                </table>
              </>
          }
        </div>
        {comprehensiveReportData.comprehensiveReportData?.length === 0 && !loader&&    
            <div className='text-danger text-center'>There are no students with this assignment.</div>
        }
        <h5 className='mt-5'>Legend</h5>
        <ul>
          <li>U: Unscored</li>
          <li>*: Score for Constructed Response Question</li>
        </ul>
      </div>
      <Modals
        isOpen={openStandardModal}
        onClose={() => setOpenStandardModal(false)}
        details={viewStandardDetails}
      />
    </>
  );
};

export default ComprehensiveReport;
